module.exports = __webpack_public_path__ + "img/slide_002_g1.14f600ea.jpg";